import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "../../../config/api";
import { BackEndRoutes } from "../../../config/back-end-routes";
import { FrontEndRoutes } from "../../../config/front-end-routes";
import { InputMask } from "@react-input/mask";
import CustomerAddress from "../../../Components/FormCustomer/CustomerAddress";
import InputCep from "../../../Components/InputText/InputCep";
import InputNumber from "../../../Components/InputText/InputNumber";
import {IMaskInput} from "react-imask";

interface FormUserSettingsProps {
    configData: any;
    setConfigData: (data: any) => void;
}

const FormUserSettings: React.FC<FormUserSettingsProps> = ({ configData, setConfigData }) => {
    const navigate = useNavigate();
    const { id } = useParams<{ id: string }>();
    const [loading, setLoading] = useState(false);

    const applyMask = (value: string | undefined, mask: string): string => {
        if (!value) return "";
        let maskedValue = "";
        let valueIndex = 0;

        for (let i = 0; i < mask.length && valueIndex < value.length; i++) {
            if (mask[i] === "_") {
                maskedValue += value[valueIndex];
                valueIndex++;
            } else {
                maskedValue += mask[i];
            }
        }
        return maskedValue;
    };

    const handleMaskedChange = (
        e: React.ChangeEvent<HTMLInputElement>,
        mask: string
    ) => {
        const rawValue = e.target.value.replace(/\D/g, ""); // Remove caracteres não numéricos
        const maskedValue = applyMask(rawValue, mask);
        setConfigData((prev: any) => ({ ...prev, [e.target.name]: maskedValue }));
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setConfigData((prev: any) => ({ ...prev, [name]: value }));
    };

    useEffect(() => {
        if (id) {
            setLoading(true);
            api.get(`${BackEndRoutes.routes.CLIENTES.GET}/${id}`)
                .then((response) => {
                    const data = response.data;

                    // Aplicar máscaras aos campos
                    data.telefone = applyMask(data.telefone, "(__)____-____");
                    data.celular = applyMask(data.celular, "(__)_____-____");
                    data.estado = data.estado?.toUpperCase();

                    setConfigData(data);
                })
                .catch((error) => console.error("Erro ao buscar dados do cliente", error))
                .finally(() => setLoading(false));
        }
    }, [id, setConfigData]);



    return (
        <div>
            <div className="tab-content mt-3 border border-top-0 rounded-bottom" id="myTabContent">
                <div className="tab-pane fade show active" id="dados" role="tabpanel" aria-labelledby="dados-tab">
                    <div className="card-body row d-flex justify-content-center">
                        <div className="container-fluid pb-4 pt-0">
                            <div className="row">
                                <div className="col-md-6 col-lg-4">
                                    <label>CNPJ</label>
                                    <IMaskInput
                                        className="form-control"
                                        name="cnpj_utilizador"
                                        disabled
                                        value={configData?.cnpj_utilizador || ""}
                                        onChange={handleChange}
                                        placeholder="00.000.000/0000-00"
                                        mask="00.000.000/0000-00"
                                    />
                                </div>
                                <div className="col-md-6 col-lg-4">
                                    <label>IE (Inscrição estadual)</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        name="ie_utilizador"
                                        value={configData?.ie_utilizador || ""}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="col-md-6 col-lg-4">
                                    <label>Razão Social</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        name="razao_social"
                                        value={configData?.razao_social || ""}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="col-md-6 col-lg-4">
                                    <label>Nome Fantasia</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        name="nome_fantasia"
                                        value={configData?.nome_fantasia || ""}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="col-md-6 col-lg-4">
                                    <label>Telefone</label>
                                    <IMaskInput
                                        className="form-control"
                                        name="telefone"
                                        value={configData?.telefone || ""}
                                        onChange={handleChange}
                                        placeholder="(00)0000-0000"
                                        mask="(00)0000-0000"
                                    />
                                </div>
                                <div className="col-md-6 col-lg-4">
                                    <label>Celular</label>
                                    <IMaskInput
                                        className="form-control"
                                        name="celular"
                                        value={configData?.celular || ""}
                                        onChange={handleChange}
                                        placeholder="(00)00000-0000"
                                        mask="(00)00000-0000"
                                    />
                                </div>
                                <div className="col-md-6 col-lg-4">
                                    <label>Email</label>
                                    <input
                                        className="form-control"
                                        type="email"
                                        name="email"
                                        value={configData?.email || ""}
                                        onChange={handleChange}
                                        placeholder="email@dominio.com"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="border-top border-2 border-secondary-subtle p-4">
                            <h5 className="mb-4">Informações do Endereço</h5>
                            <div className="row">
                                <div className="col-md-3 col-lg-3">
                                    <label>CEP</label>
                                    <IMaskInput
                                        className="form-control"
                                        name="cep"
                                        value={configData?.cep || ""}
                                        onChange={handleChange}
                                        placeholder="00000-000"
                                        mask="00000-000"
                                    />
                                </div>
                                <div className="col-md-6">
                                    <label>Endereço</label>
                                    <input
                                        id="endereco"
                                        className="form-control"
                                        type="text"
                                        value={configData?.endereco}
                                        placeholder="Endereço"
                                        onChange={handleChange}
                                    />
                                    <p className="invalid-feedback">Insira um Endereço</p>
                                </div>
                                <div className="col-md-3 col-lg-3">
                                    <label>número</label>
                                    <input
                                        className="form-control"
                                        type="numero"
                                        name="numero"
                                        value={configData?.numero || ""}
                                        onChange={handleChange}
                                        placeholder="Número"
                                    />
                                </div>
                                <div className="col-md-3">
                                    <label>Complemento</label>
                                    <input
                                        id="complemento"
                                        className="form-control"
                                        type="text"
                                        value={configData?.complemento}
                                        placeholder="Complemento"
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="col-md-3">
                                    <label>Bairro</label>
                                    <input
                                        id="bairro"
                                        className="form-control"
                                        type="text"
                                        value={configData?.bairro}
                                        placeholder="Bairro"
                                        onChange={handleChange}
                                    />
                                    <p className="invalid-feedback">Insira um Bairro</p>
                                </div>
                                <div className="col-md-4">
                                    <label>Cidade</label>
                                    <input
                                        id="cidade"
                                        className="form-control"
                                        type="text"
                                        value={configData?.cidade}
                                        placeholder="Cidade"
                                        onChange={handleChange}
                                    />
                                    <p className="invalid-feedback">Insira uma Cidade</p>
                                </div>
                                <div className="col-md-2">
                                    <label>Estado</label>
                                    <input
                                        id="estado"
                                        className="form-control"
                                        type="text"
                                        value={configData?.estado.toUpperCase()}
                                        placeholder="Estado"
                                        onChange={handleChange}
                                    />
                                    <p className="invalid-feedback">Insira um Estado</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FormUserSettings;
